import { useState, useEffect, useRef } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  List,
  ListItem,
  Box,
  Tabs,
  Stack,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { useForm, Controller } from "react-hook-form";
import Badge from "components/badge";
import { useDispatch, useSelector } from "react-redux";
import { setOpenModal, addSaleFood } from "../store/saleSlice";

const FoodAdd = () => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const open = useSelector(({ sale }) => sale.saleSlice.openModal);
  const foodOptions = useSelector(({ sale }) => sale.saleSlice.foodOptions);

  const [searchValue, setSearchValue] = useState("");
  const [selectedFood, setSelectedFood] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState([]);

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      price: null,
      count: null,
    },
  });

  const onSubmit = (data) => {
    const payload = {
      ...data,
      food: selectedFood.id,
    };

    dispatch(addSaleFood(payload));
  };

  useEffect(() => {
    setFilteredOptions(foodOptions);
  }, [foodOptions]);

  useEffect(() => {
    setSearchValue("");
    setSelectedFood(null);
    setFilteredOptions(foodOptions);
    reset();
    // eslint-disable-next-line
  }, [open]);

  const onClose = () => {
    dispatch(setOpenModal(false));
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    // Filter type_foods by type === 1
    const filtered = foodOptions.map((item) => ({
      ...item,
      type_foods: item.type_foods.filter((food) =>
        food.name.toLowerCase().includes(value.toLowerCase())
      ),
    }));

    setFilteredOptions(filtered);
  };

  const handleSelectFood = (food) => {
    reset();
    setSelectedFood(food);
    setSearchValue("");
    inputRef.current?.focus();
    setFilteredOptions(foodOptions);
  };

  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalOverlay />

      <ModalContent w="750px" maxW="90%">
        <ModalHeader>
          <div className="flex items-center gap-3">
            Хоол нэмэх
            <div className="text-[13px] font-normal mt-[3px]">/борлуулах/</div>
          </div>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Input
            placeholder="Хайх..."
            value={searchValue}
            onChange={handleSearch}
            mb="4"
          />

          {selectedFood && (
            <Box mt={2} mb={5}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Stack direction="row" gap={4}>
                  <Badge
                    key={1}
                    index={1}
                    text={selectedFood.name}
                    remove={() => setSelectedFood(null)}
                  />

                  <Controller
                    name="price"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        ref={(e) => {
                          field.ref(e); // Connect react-hook-form to the input ref
                          inputRef.current = e; // Store ref for focusing
                        }}
                        onWheel={(e) => e.target.blur()}
                        placeholder="Хоолны үнэ"
                        type="number"
                        size="sm"
                        maxWidth={120}
                        required
                      />
                    )}
                  />
                  <Controller
                    name="count"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        onWheel={(e) => e.target.blur()}
                        placeholder="Хоолны зарах тоо"
                        type="number"
                        size="sm"
                        maxWidth={150}
                        required
                      />
                    )}
                  />
                  <Button colorScheme="customGreen" size="sm" type="submit">
                    Нэмэх
                  </Button>
                </Stack>
              </form>
            </Box>
          )}

          <Tabs>
            <TabList>
              {filteredOptions.map((f, i) => (
                <Tab key={f.id} className="font-semibold !text-[14px]">
                  {f.name}
                </Tab>
              ))}
            </TabList>

            <TabPanels>
              {filteredOptions.map((option) => {
                return (
                  <TabPanel key={option.id}>
                    <Box maxH="350px" minH="300px" overflowY="auto" mb="5">
                      <List spacing={3}>
                        {option.type_foods.map((option) => (
                          <ListItem
                            key={option.id}
                            py="2"
                            px="4"
                            cursor="pointer"
                            bg="gray.100"
                            fontSize="sm"
                            _hover={{ bg: "blue.300", color: "white" }}
                            borderRadius="md"
                            onClick={() => handleSelectFood(option)}
                          >
                            {option.name}
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  </TabPanel>
                );
              })}
            </TabPanels>
          </Tabs>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default FoodAdd;
